import { mapState } from 'vuex';
import FieldValidator from '@/views/calculators/services/fieldValidatorService';
import { CarSettings } from '../CarSettings';
import ExistingAbProductsComponent from '../../components/ExistingABProductsComponent.vue';
import { Options, Vue } from 'vue-class-component';
import { nextTick, PropType } from 'vue';
import { CardBlock } from '@/cms/definitions/content-types';
import store from '@/store/store';
import { Validator } from '../../services/ValidationService';
import { copyAddress, mapDawaAddress, resetAddress } from '@/views/calculators/services/addressMappingService';
import { CarModel } from '../CarModel';
import { handleAddressPrefill, getCustomerReadonlyAge } from '../../services/UiStepService';

@Options({
	name: 'PersonInfoStepComponent',
	props: {
		card: Object as PropType<CardBlock>,
		isValid: Boolean,
	},
	components: {
		ExistingAbProductsComponent,
	},
	computed: mapState<any>({
		model: (state) => state.calculatorContext[state.calculatorContext.active].model,
		cms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
	}),
})
export default class PersonInfoStepComponent extends Vue {
	card: CardBlock; // Card from cms
	isValid: boolean; // wether card is complete

	public model!: CarModel; // data structure for user input (store)
	public cms!: CarSettings; // settings from CMS (store)
	public defaultAddress: string = null;

	public updateCarOwnerYears = 'updateCarOwnerYears';
	public fieldValidator: FieldValidator = Validator;
	public readonlyAge: string = null;
	public readonlyCarOwnerYears: string = null;

	public created() {
		const addressParam = this.$route.query.address as string;
		if (addressParam) {
			this.defaultAddress = addressParam;
		}
	}

	public mounted() {
		// DEBUG this.model.carInfo.carOwnerYears = this.readonlyCarOwnerYears;
		handleAddressPrefill(this.model.personInfo, this.cms);

		if (this.model.personInfo.customerAge) {
			this.setCarOwnerArray();
		}

		this.readonlyAge = getCustomerReadonlyAge(this.model);

		if (this.model.multipleProducts) {
			const basket = store.getters.getSelectableGroup('basket');
			const activeIndex = store.getters.getActiveCalculatorInx;

			basket.forEach((product) => {
				if (product.includes(this.model.productName) && product !== this.model.productName + activeIndex) {
					const calc = store.getters.getCalculator(product);
					const carOwnerYears = calc?.model?.carInfo.carOwnerYears;
					if (calc?.model?.personInfo && calc?.model?.carInfo) {
						this.handleReadOnlyValues(calc, carOwnerYears);
					}
				}
			});
		}

		addEventListener('keyup', this.moveOn);
	}

	private handleReadOnlyValues(calc, carOwnerYears) {
		if (carOwnerYears) {
			this.model.carInfo.carOwnerYears = carOwnerYears;
			this.readonlyCarOwnerYears = carOwnerYears;
			this.updateCarOwnerYears += 1;
		}
		if (!this.readonlyAge && this.fieldValidator.isValidAge(calc.model.personInfo.customerAge)) {
			this.model.personInfo.customerAge = calc.model.personInfo.customerAge;
			this.readonlyAge = this.model.personInfo.customerAge;
		}
	}
	public beforeUnmount() {
		removeEventListener('keyup', this.moveOn);
	}

	public moveOn(evt) {
		if (evt.keyCode === 13 && this.isValid) {
			this.nextStep();
		}
	}

	public async addressSearch(address) {
		if (address?.matchText) {
			await mapDawaAddress(this.model.personInfo, address);
			copyAddress(this.model.personInfo, this.model.personInfo.homeAddress); // since we only save address on personInfo for now, we need to map it to homeAddress for the basket

			this.model.pristineStep.set(this.card.name, true);
			if (this.model.personInfo.customerAge) {
				this.setCarOwnerArray();
				nextTick(() => {
					setTimeout(() => {
						(document.activeElement as any).blur();
					}, 300);
				});
			} else {
				nextTick(() => {
					// wait for transition to begin showing customerAge field
					setTimeout(() => {
						const input = document.getElementById('customerAge');
						if (input) {
							input.focus();
						}
					}, 300);
				});
			}
			return;
		}

		resetAddress(this.model.personInfo);
		resetAddress(this.model.personInfo.homeAddress);
	}

	public setCarOwnerArray() {
		if (this.fieldValidator.isValidAge(this.model.personInfo.customerAge)) {
			this.model.personInfo.customerAge = this.model.personInfo.customerAge.trim().replace(/\D/g, ''); // clean customerAge input
			const maxCarOwnerYears = Number.parseInt(this.model.personInfo.customerAge) - 17; // if customerAge = 18, then user could have 1 year experience
			this.model.carInfo.carOwnerYearsByAgeArray = this.cms.carOwnerYears.slice(0, maxCarOwnerYears + 1); // since first choice is no experience driving
			if (
				this.model.carInfo.carOwnerYears &&
				!this.model.carInfo.carOwnerYearsByAgeArray.includes(this.model.carInfo.carOwnerYears)
			) {
				this.model.carInfo.carOwnerYears = undefined;
				this.updateCarOwnerYears += 1;
			}
		}
	}

	public selectCarOwnerYears(evt) {
		this.model.carInfo.carOwnerYears = evt.selectedValue;
	}

	public nextStep() {
		this.$emit('nextStep', this.card.routePath);
	}
}
